import WaveSurfer from "wavesurfer.js";
import Timeline from "wavesurfer.js/dist/plugins/timeline";
import Regions from "wavesurfer.js/dist/plugins/regions";

export class TranscriptionViewerAudioPlayer extends HTMLElement {
  constructor() {
    super();
    this.handleSeekTimeEvent = this.handleSeekTimeEvent.bind(this);
 }

  handleSeekTimeEvent(e) {
    if (e.detail.newTime) {
      this.wavesurfer.setTime( e.detail.newTime );
    }
    else if (e.detail.startTime) {
      this.wavesurfer.setTime( e.detail.startTime );
      this.regions.clearRegions();
      this.regions.addRegion({
        start: e.detail.startTime,
        end: e.detail.endTime,
        drag: false,
      })

      // have to change the title manually
      const region = document.querySelector('region')
      if (region){
        region.setAttribute("title", e.detail.keyword);
      }
    }  
  }

  connectedCallback() {
    this.innerHTML = `
      <div class="container-div" style="background-color: lightgray">
        <div class="waveform-container" style="margin: 0px 10px"></div>
          <div id="wave-timeline-container" style="margin: 0px 10px"></div>
          <audio id="wavesurfer-media-element" controls style="width: 100%"></audio>
      </div>
    `;

    this.waveformContainer = this.querySelector(".waveform-container");
    this.wavesurfer = WaveSurfer.create({
      container: this.waveformContainer,
      barHeight: 4,
      barRadius: 1,
      barWidth: 1,
      cursorWidth: 2,
      cursorColor: "darkgrey",
      height: 128/2,
      hideScrollbar: true,
      progressColor: "white",
      normalize: true,
      media: this.querySelector("#wavesurfer-media-element"),
    });

    this.wavesurfer.registerPlugin(
      Timeline.create({ container: this.querySelector("#wave-timeline-container") })
    );

    this.regions = this.wavesurfer.registerPlugin(Regions.create());

    this.wavesurfer.load(this.getAttribute("src"));


    // this.wavesurfer.on("ready", () => {
    //   console.log("time: " + typeof this.wavesurfer.getCurrentTime())
    //   this.wavesurfer.addRegion({
    //     start: 10.0,
    //     end: 40.0,
    //     drag: false
    //   })
    // });

    this.wavesurfer.on("seeking", () => {
      // console.log("seek time: " + this.wavesurfer.getCurrentTime())
      this.dispatchTimeUpdateEvent();
    });

    // this.wavesurfer.on("scroll", () => {
    //   console.log("scroll time: " + this.wavesurfer.getCurrentTime())
    // });

    this.wavesurfer.on("audioprocess", () => {
      this.dispatchTimeUpdateEvent();
    });

    document.addEventListener("newSeekTimeForAudioPlayer", this.handleSeekTimeEvent);
    // document.addEventListener("newSeekTimeForAudioPlayer", (e) => {
    //   if (e.detail.newTime) {
    //     this.wavesurfer.setCurrentTime( e.detail.newTime );
    //   }
    //   else if (e.detail.startTime) {
    //     this.wavesurfer.setCurrentTime( e.detail.startTime );

    //     this.wavesurfer.clearRegions();
    //     this.wavesurfer.addRegion({
    //       start: e.detail.startTime,
    //       end: e.detail.endTime,
    //       drag: false,
    //     })

    //     // have to change the title manually
    //     const region = document.querySelector('region')
    //     if (region){
    //       region.setAttribute("title", e.detail.keyword);
    //     }
    //   }
    // })
  }

  dispatchTimeUpdateEvent(){
    this.dispatchEvent(new CustomEvent('audioPlayerTimeUpdate', 
      {bubbles: true, detail: {currentTime: this.wavesurfer.getCurrentTime()}}
    ))  
  }

  disconnectedCallback() {
    document.removeEventListener("newSeekTimeForAudioPlayer", this.handleSeekTimeEvent);
    this.wavesurfer.destroy();
  }
}

customElements.define("transcription-viewer-audio-player", TranscriptionViewerAudioPlayer);
